export default {
    root: {
        background: '{content.background}',
        borderColor: '{content.border.color}',
        color: '{content.color}',
        borderRadius: '{content.border.radius}'
    },
    header: {
        background: 'transparent',
        color: '{text.color}',
        padding: '1.125rem',
        borderWidth: '0 0 1px 0',
        borderColor: '{content.border.color}',
        borderRadius: '0'
    },
    toggleableHeader: {
        padding: '0.375rem 1.125rem'
    },
    title: {
        fontWeight: '700'
    },
    content: {
        padding: '1.125rem'
    },
    footer: {
        padding: '0 1.125rem 1.125rem 1.125rem'
    }
};
